var map = {
	"./img1.png": 9849,
	"./img10.png": 7149,
	"./img11.png": 3908,
	"./img12.png": 9183,
	"./img13.png": 5382,
	"./img14.png": 5353,
	"./img15.png": 1152,
	"./img2.png": 1666,
	"./img3.png": 3211,
	"./img4.png": 8404,
	"./img5.png": 1645,
	"./img6.png": 9878,
	"./img7.png": 3679,
	"./img8.png": 264,
	"./img9.png": 8657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8798;